module.exports = __webpack_public_path__ + "static/media/mettle.f63d5651.svg";